import one360 from './one360';
import type { ProjektdokumentationFormData, ProjektdokumentationStatusUpdate, ProjektdokumentationStoredRecord, ProjektdokumentationTemplate } from '../../types/projektdokumentation';
import type { ProjectStatusSnapshot } from '../../types/hubspot';

export interface ProjektdokumentationStatusUpdateResult {
  projectStatus?: Partial<ProjectStatusSnapshot>;
  record?: ProjektdokumentationStoredRecord;
}

export const getProjektdokumentationTemplate = async (
  projectId: string
): Promise<ProjektdokumentationTemplate> =>
  one360.get<ProjektdokumentationTemplate>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation-template`);

export const upsertProjektdokumentation = async (
  projectId: string,
  payload: ProjektdokumentationFormData
): Promise<ProjektdokumentationStatusUpdateResult> =>
  one360.put<ProjektdokumentationStatusUpdateResult>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation`, payload);

export const updateProjektdokumentationStatus = async (
  projectId: string,
  payload: ProjektdokumentationStatusUpdate
): Promise<ProjektdokumentationStatusUpdateResult> =>
  one360.post<ProjektdokumentationStatusUpdateResult>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation/status`, payload);
